<template>
  <div class="spinner-loading-native" :style="spinnerStyle">
    <div class="spinner-ring" :style="ringStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'spinner-loading',
  props: {
    size: { type: [Number, String], default: 18 },
    lineSize: { type: [Number, String], default: 3 },
    lineFgColor: { type: String, default: '#5dbecd' },
    lineBgColor: { type: String, default: 'transparent' }
  },
  computed: {
    spinnerStyle () {
      return { width: this.size + 'px', height: this.size + 'px' }
    },
    ringStyle () {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        borderWidth: this.lineSize + 'px',
        borderColor: this.lineBgColor,
        borderTopColor: this.lineFgColor
      }
    }
  }
}
</script>

<style scoped>
.spinner-loading-native {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.spinner-ring {
  border-style: solid;
  border-radius: 50%;
  animation: spinner-spin 0.75s linear infinite;
  box-sizing: border-box;
}
@keyframes spinner-spin {
  to { transform: rotate(360deg); }
}
</style>
